// Gift finder: turns three answers (who, what they love, budget) into a link to the matching category page.
class GiftFinder extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(this.form);
      const love = this.form.querySelector('input[name="love"]:checked');
      let url = love ? love.dataset.url : this.dataset.fallback;
      const who = data.get('who');
      const tags = love ? (love.dataset.tags || '').split(' ') : [];
      if (who && tags.includes(who)) url += '/' + who;
      if (data.get('budget') === 'under') url += '?filter.v.price.lte=' + this.dataset.budgetMax;
      window.location.href = url;
    });
  }
}
if (!customElements.get('s-gift-finder')) customElements.define('s-gift-finder', GiftFinder);
